import SlideoutComponent from './components/slideout.js'

const Slideout = SlideoutComponent

export default Slideout



// WEBPACK FOOTER //
// ./src/plugin/plugin.js